// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BulkFillController from "./bulk_fill_controller"
application.register("bulk-fill", BulkFillController)

import DateRangePickerController from "./date_range_picker_controller"
application.register("date-range-picker", DateRangePickerController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DepartmentsController from "./departments_controller"
application.register("departments", DepartmentsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ManagerSelectorController from "./manager_selector_controller"
application.register("manager-selector", ManagerSelectorController)

import MonthPlanFiltersController from "./month_plan_filters_controller"
application.register("month-plan-filters", MonthPlanFiltersController)

import MonthPlanGridController from "./month_plan_grid_controller"
application.register("month-plan-grid", MonthPlanGridController)

import PasswordController from "./password_controller"
application.register("password", PasswordController)

import SalaryStateController from "./salary_state_controller"
application.register("salary-state", SalaryStateController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import Select2UsersController from "./select2_users_controller"
application.register("select2-users", Select2UsersController)

import WorkDaysController from "./work_days_controller"
application.register("work-days", WorkDaysController)
